import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import LoanCreateModalUI from './LoanCreateModalUI.js'

class LoanCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      loanName: '',
      loanNameError: null,
      loanType: 'project',
      loanTypeError: null,
      loanTypeList: [],
      appFlavor: 'classic',
      appFlavorError: null,
      appFlavorList: [],
      loanPurpose: '',
      loanPurposeError: null,
      loanPurposeList: [],
      loanSubType: '',
      loanSubTypeError: null,
      loanSubTypeList: [],
      loanAmountF: '',
      loanAmountFError: null,
      tenureMonths: '',
      tenureMonthsError: null,
      capex: false,
      sectorList: [],
      loanTenureMonths: '',
      loanTenureMonthsError: null,
      interestTenureMonths: '',
      interestTenureMonthsError: null,
    }
  }

  render() {
    return (
      <LoanCreateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelCreate={this.onCancelCreate}
        // form fields
        loanName={this.state.loanName}
        onLoanNameChange={(event) => { this.setState({ loanName: event.target.value }) }}
        loanNameError={this.state.loanNameError}
        setLoanNameError={(error) => { this.setState({ loanNameError: error }) }}
        //
        loanAmountF={this.state.loanAmountF}
        onLoanAmountFChange={(event) => { this.setState({ loanAmountF: event.target.value }) }}
        loanAmountFError={this.state.loanAmountFError}
        setLoanAmountFError={(error) => { this.setState({ loanAmountFError: error }) }}
        //
        tenureMonths={this.state.tenureMonths}
        onTenureMonthsChange={(event) => { this.setState({ tenureMonths: event.target.value }) }}
        tenureMonthsError={this.state.tenureMonthsError}
        setTenureMonthsError={(error) => { this.setState({ tenureMonthsError: error }) }}
        //
        loanType={this.state.loanType}
        onLoanTypeChange={this.onLoanTypeChange}
        loanTypeError={this.state.loanTypeError}
        setLoanTypeError={(error) => { this.setState({ loanTypeError: error }) }}
        loanTypeList={this.state.loanTypeList}
        //
        appFlavor={this.state.appFlavor}
        onAppFlavorChange={this.onAppFlavorChange}
        appFlavorError={this.state.appFlavorError}
        setAppFlavorError={(error) => { this.setState({ appFlavorError: error }) }}
        appFlavorList={this.state.appFlavorList}
        //
        loanSubType={this.state.loanSubType}
        onLoanSubTypeChange={(event) => { this.setState({ loanSubType: event.target.value }) }}
        loanSubTypeError={this.state.loanTypeError}
        setLoanSubTypeError={(error) => { this.setState({ loanSubTypeError: error }) }}
        loanSubTypeList={this.state.loanSubTypeList}
        //
        loanPurpose={this.state.loanPurpose}
        onLoanPurposeChange={this.onLoanPurposeChange}
        loanPurposeError={this.state.loanPurposeError}
        setLoanPurposeError={(error) => { this.setState({ loanPurposeError: error }) }}
        loanPurposeList={this.state.loanPurposeList}
        sectorList={this.state.sectorList}
        //
        capex={this.state.capex}
        onCapexChange={(event) => { this.setState({ capex: !this.state.capex }) }}
        //
        loanTenureMonths={this.state.loanTenureMonths}
        onLoanTenureMonthsChange={(event) => { this.setState({ loanTenureMonths: event.target.value }) }}
        loanTenureMonthsError={this.state.loanTenureMonthsError}
        setLoanTenureMonthsError={(error) => { this.setState({ loanTenureMonthsError: error }) }}
        //
        interestTenureMonths={this.state.interestTenureMonths}
        onInterestTenureMonthsChange={(event) => { this.setState({ interestTenureMonths: event.target.value }) }}
        interestTenureMonthsError={this.state.interestTenureMonthsError}
        setInterestTenureMonthsError={(error) => { this.setState({ interestTenureMonthsError: error }) }}
        showInterestTenureMonths={this.state.showInterestTenureMonths}
      />
    )
  }

  onLoanTypeChange = (event) => {
    this.setState({
      loanType: event.target.value,
    })
  }

  onAppFlavorChange = (event) => {
    this.setState({
      appFlavor: event.target.value,
    })
  }

  onLoanPurposeChange = (event) => {
    this.setState({
      loanPurpose: event.target.value,
    })
  }

  onCancelCreate = () => {
    this.setState({
      submitted: false, successMsg: null, errorList: null,
      loanName: null, loanTypeError: null,
      appFlavorError: null, loanPurposeError: null,
      loanAmountFError: null
    })
    this.props.onCancelCreate()
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
    // let loanTypeList = [
    //   { key: 'project', value: 'Amortized' },
    //   { key: 'interest_only', value: 'Interest only' },
    //   { key: 'int_then_prj', value: 'Hybrid' },
    //   { key: 'inv_discount', value: 'Receivable financing' },
    //   { key: 'lease', value: 'Lease' },
    // ]
    let appFlavorList = [
      { key: 'classic', value: 'Classic' },
      { key: 'small_loan', value: 'Straight-through processing (STP)' },
    ]
    let loanPurposeList = [
      { key: 'e_mobility', value: 'E-Mobility' },
      { key: 'renewable_energy', value: 'Renewable Energy' },
      { key: 'agri_tech', value: 'Agri Tech' },
      { key: 'health_tech', value: 'Health Tech' },
      { key: 'other', value: 'Other - Climate/ESG Project' },
    ]
    this.setState({
      // loanTypeList: loanTypeList,
      appFlavorList: appFlavorList, loanPurposeList: loanPurposeList
    })
    this.getLoanTypeList(context)
    this.getLoanSubTypeList(context)
    this.getSectors(context)
  }

  getLoanTypeList(context) {
    let cacheManager = new CacheManager({
      resource: `/api/reference/loanTypes`,
      cacheKey: CacheKeys.LoanTypeList(),
      callback: this.getLoanTypeListCallback,
      ttlInSecs: 36000
    })
    cacheManager.getObject2(context)
  }

  getLoanTypeListCallback = (response) => {
    this.setState({ errorList: response.errorList, loanTypeList: response.keyValueList })
  }

  getLoanSubTypeList(context) {
    let cacheManager = new CacheManager({
      resource: `/api/reference/loan/subTypes`,
      cacheKey: CacheKeys.LoanSubTypeList(),
      callback: this.getLoanSubTypeListCallback,
      ttlInSecs: 36000
    })
    cacheManager.getObject2(context)
  }

  getLoanSubTypeListCallback = (response) => {
    let loanSubTypeList = response.loanSubTypeList.map((loanSubType) => {
      return { key: loanSubType.code, value: loanSubType.title }
    });
    this.setState({ errorList: response.errorList, loanSubTypeList: loanSubTypeList })
  }

  getSectors(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/references`,
      cacheKey: CacheKeys.Sectors(),
      callback: this.getSectorsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getSectorsCallback = (response) => {
    let sectorList = response.sectorList.map((sectors) => {
      return { key: sectors.name, value: sectors.label };
    });
    this.setState({ errorList: response.errorList, sectorList: sectorList })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/loans`,
      this.onSubmitCallback, {
      loanName: this.state.loanName,
      loanType: this.state.loanType,
      loanSubType: this.state.loanSubType,
      loanAmount: this.state.loanAmountF,
      tenureMonths: this.state.tenureMonths,
      appFlavor: this.state.appFlavor,
      purpose: this.state.loanPurpose,
      capex: this.state.capex,
      loanTenureMonths: this.state.loanTenureMonths,
      interestTenureMonths: this.state.interestTenureMonths,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.Loans())
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelCreate()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default LoanCreateModalSF
